import {
  CAT_PRODUCTS,
  CAT_COMPONENTS,
  CAT_COMPANIES,
  CAT_CONTACTS,
  CAT_TRADEMARKS,
  CAT_BRANDS,
  CAT_PATENTS,
  CAT_EVENTS,
  CAT_STANDING_REPORTS,
  CAT_RESEARCHES,
  CAT_COMPANY_NEWS,
  CAT_FEATURE_OPTIONS,
  CAT_AI_NEWS,
  CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM,
  CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK,
  CAT_SOCIAL_MEDIA_SCRAPER_X,
  CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE,
  CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN,
  CAT_SOCIAL_MEDIA_SCRAPER_ALL,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS,
  CAT_NEWSLETTER_EMAILS,
  CAT_NEWSLETTER_DOMAINS,
  CAT_NEWS,
  CAT_VARIATIONS,
  CAT_PRODUCT_ORDERS,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_ANALYZE_REQUESTS,
  CAT_WEBSITE_SERVICES,
  CAT_STATUSES,
  CAT_CUSTOMERS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_PROJECTS,
  CAT_AGENTS,
  CAT_ATTENDING_REQUESTS,
  CAT_FILES,
  CAT_CONSUMABLE_VARIATIONS,
  CAT_TYPES,
  CAT_FEATURES,
  CAT_AI_NEWS_PROMPTS,
  CAT_SAMPLES,
  CAT_ACTIVITY_SPHERES,
  CAT_INGREDIENT_CATEGORIES,
  CAT_INFORMATION_SOURCES,
  CAT_AI_SEARCH,
} from 'App/constants/categories';

export const PLACEHOLDERS_BY_CATEGORY = {
  [CAT_PRODUCTS]: {
    default: 'searchModule.products.default',
    spec: 'searchModule.products.spec',
    strict: 'searchModule.products.strict',
    specStrict: 'searchModule.products.specStrict',
    specDesc: 'searchModule.products.specDesc',
    description: 'searchModule.products.description',
  },
  [CAT_COMPONENTS]: 'searchModule.components',
  [CAT_COMPANIES]: Object.assign(
    (isStaff, isCustomer, isVaping, routeParams) => {
      if (isStaff) {
        return 'searchModule.companies.staff';
      }
      if (isCustomer && isVaping && routeParams?.subcategory === 'smoking-alternatives') {
        return 'searchModule.companies.staff';
      }
      return 'searchModule.companies.customer';
    },
    {
      description: 'searchModule.companies.description',
    }
  ),
  [CAT_CONTACTS]: 'searchModule.contacts',
  [CAT_TRADEMARKS]: 'searchModule.trademarks',
  [CAT_BRANDS]: 'searchModule.brands',
  [CAT_PATENTS]: Object.assign(
    (hasRole) => (hasRole ? 'searchModule.patents.hasRole' : 'searchModule.patents.noRole'),
    {
      claims: 'searchModule.patents.claims',
      description: 'searchModule.patents.description',
      claimsDescription: 'searchModule.patents.claimsDescription',
    }
  ),
  [CAT_EVENTS]: 'searchModule.events',
  [CAT_STANDING_REPORTS]: 'searchModule.standing_reports',
  [CAT_RESEARCHES]: (isCMS) => {
    return isCMS ? 'searchModule.research.cms' : 'searchModule.research.default';
  },
  [CAT_COMPANY_NEWS]: 'searchModule.company_news',
  [CAT_FEATURE_OPTIONS]: 'searchModule.feature_options',
  [CAT_AI_NEWS]: 'searchModule.ai_news',
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM]: 'searchModule.instagram',
  [CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK]: 'searchModule.facebook',
  [CAT_SOCIAL_MEDIA_SCRAPER_X]: 'searchModule.x',
  [CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE]: 'searchModule.youtube',
  [CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN]: 'searchModule.linkedin',
  [CAT_SOCIAL_MEDIA_SCRAPER_ALL]: 'searchModule.all',
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS]: 'searchModule.core_results',
  [CAT_NEWSLETTER_EMAILS]: 'searchModule.newsletter-emails',
  [CAT_NEWSLETTER_DOMAINS]: 'searchModule.newsletter-domains',
  [CAT_NEWS]: 'searchModule.news',
  [CAT_VARIATIONS]: {
    default: 'searchModule.variations.default',
    decodedFlavors: 'searchModule.variations.decodedFlavors',
    description: 'searchModule.variations.description',
    flavorClaims: 'searchModule.variations.flavorClaims',
    chemicalFormula: 'searchModule.variations.chemicalFormula',
    // pairs
    decodedFlavors_description: 'searchModule.variations.decodedFlavors_description',
    decodedFlavors_flavorClaims: 'searchModule.variations.decodedFlavors_flavorClaims',
    decodedFlavors_chemicalFormula: 'searchModule.variations.decodedFlavors_chemicalFormula',
    description_flavorClaims: 'searchModule.variations.description_flavorClaims',
    description_chemicalFormula: 'searchModule.variations.description_chemicalFormula',
    flavorClaims_chemicalFormula: 'searchModule.variations.flavorClaims_chemicalFormula',
    // triples
    decodedFlavors_description_flavorClaims: 'searchModule.variations.decodedFlavors_description_flavorClaims',
    decodedFlavors_description_chemicalFormula: 'searchModule.variations.decodedFlavors_description_chemicalFormula',
    decodedFlavors_flavorClaims_chemicalFormula: 'searchModule.variations.decodedFlavors_flavorClaims_chemicalFormula',
    description_flavorClaims_chemicalFormula: 'searchModule.variations.description_flavorClaims_chemicalFormula',
    // all
    decodedFlavors_description_flavorClaims_chemicalFormula:
      'searchModule.variations.decodedFlavors_description_flavorClaims_chemicalFormula',
  },
  [CAT_PRODUCT_ORDERS]: 'searchModule.orders',
  [CAT_WEBSITE_DEALS]: 'searchModule.website_deals',
  [CAT_INFO_REQUESTS]: 'searchModule.info_requests',
  [CAT_ANALYZE_REQUESTS]: 'searchModule.analyze_requests',
  [CAT_WEBSITE_SERVICES]: 'searchModule.website_services',
  [CAT_STATUSES]: 'searchModule.statuses',
  [CAT_CUSTOMERS]: 'searchModule.customers',
  [CAT_COURIER_DELIVERY_SERVICES]: 'searchModule.courier_delivery_services',
  [CAT_PROJECTS]: 'searchModule.projects',
  [CAT_AGENTS]: 'searchModule.agents',
  [CAT_ATTENDING_REQUESTS]: 'searchModule.attending_requests',
  [CAT_FILES]: 'searchModule.files',
  [CAT_CONSUMABLE_VARIATIONS]: 'searchModule.consumable_variations',
  [CAT_ACTIVITY_SPHERES]: 'searchModule.activity_spheres',
  [CAT_INGREDIENT_CATEGORIES]: 'searchModule.ingredient_categories',
  [CAT_TYPES]: 'searchModule.types',
  [CAT_FEATURES]: 'searchModule.features',
  [CAT_AI_NEWS_PROMPTS]: 'searchModule.ai_news_prompts',
  [CAT_SAMPLES]: 'searchModule.samples',
  [CAT_INFORMATION_SOURCES]: 'searchModule.information_sources',
  [CAT_AI_SEARCH]: 'Ask WIMS anything…',
};
